/*
 * Authors: mariushirjanu, Triadi
 * Created: 04/06/2020
 * Upgraded: 13/12/2023
 */
import * as _ from 'underscore';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IAsset } from './asset-data.service';
import { FormattingService } from '../../../shared/services/formatting.service';
import { GaFormlyService, IExtraFieldConfigurationObject } from '../../../shared/formly/ga-formly.service';
import { UntypedFormGroup } from '@angular/forms';
import { Dictionary } from 'underscore';
import { EVENT_ROW_DATA_CHANGED } from '../../../shared/form-grid/form-grid.component';
import { GaEventService, IGAEvent } from '../../../shared/services/ga-event.service';
import { Subscription } from 'rxjs';
import { CellValueChangedEvent } from 'ag-grid-community';

@Component({
  template: `
    <div class="asset-detail form-horizontal">
      <formly [fields]="fields" [model]="data" [form]="form"></formly>
    </div>`
})
export class AssetDetailComponent implements OnInit, OnDestroy {
  @Input() public data:Dictionary<IAsset>;
  @Input() public rowId:number;
  private eventHandler:Subscription;

  public fields:IExtraFieldConfigurationObject[];
  public form:UntypedFormGroup = new UntypedFormGroup({});

  constructor(
    private formlyService:GaFormlyService,
    private formattingService:FormattingService,
    private eventService:GaEventService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.fields = this.createFields();
    this.updateFieldVisibility();
    this.listen();
  }

  private listen():void {
    this.eventHandler = this.eventService.events
      .subscribe((event:IGAEvent) => {
        if(event.name === EVENT_ROW_DATA_CHANGED){
          this.updateRowData(event?.data);
        }
      });
  }

  private updateRowData = (event:CellValueChangedEvent) => {
    if(this.rowId === event?.node?.rowIndex) {
      this.data = event?.data;
      this.updateFieldVisibility();
    }
  };

  private updateFieldVisibility():void {
    _.each(this.fields, (field:IExtraFieldConfigurationObject) => {
      field.hide = true;
    });

    _.each(this.data, (value:IAsset, key:string) => {
      const field:IExtraFieldConfigurationObject = _.find(this.fields, (field:IExtraFieldConfigurationObject) => field.key === key);
      if (field) {
        field.hide = !value;
      }
    });
  }

  private createFields():IExtraFieldConfigurationObject[] {
    const wrapperClass:string = 'col-sm-6';

    return [
      this.formlyService.aValue('partNumber')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('category')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('description')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('serialNumber')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('assetTag')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('assetDescription')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('user')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('macAddress')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('mac2Address')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('imei')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('uuid')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('parentProductSerialNumber')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('warrantyExpiryDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('warrantyActivationNumber')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('leasingContractNumber')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('leasingStartDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('leasingTerm')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('leasingEndDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('rentalExtension')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('rentalEndDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('paymentPeriod')
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('beginningOfPayment')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('endOfPayment')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('shippingEstimationDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('shippingActualDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('arrivalEstimationDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('arrivalActualDate')
        .withFormat(this.formattingService.formatDate)
        .withWrapperClass(wrapperClass)
        .build(),
      this.formlyService.aValue('oemReferenceNumber')
        .withWrapperClass(wrapperClass)
        .build()
    ];
  }

  public ngOnDestroy():void {
    this.eventHandler?.unsubscribe();
  }
}